import logoImg from "../assets/logo.webp";
import linkedinImg from "../assets/icon-linkedin.svg";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { useIsMobile } from "../hooks";
import { IconButton, Link, SxProps, Theme } from "@mui/material";

const FooterStyle: Record<string, SxProps<Theme>> = {
    footer: {
        color: "rgba(255, 255, 255, 0.5) !important",
        borderTop: "1px solid rgba(255, 255, 255, 0.5)",
        alignItems: "center",
        marginTop: "20px",
        // "& .MuiTypography-root": {
            
        // },
        marginBottom: "20px",
        paddingLeft: "50px",
        paddingRight: "50px",
        paddingTop: "20px"
    },
    footerMobile: {
        color: "rgba(255, 255, 255, 0.5) !important",
        borderTop: "1px solid rgba(255, 255, 255, 0.5)",
        alignItems: "center",
        marginTop: "20px",
        // "& .MuiTypography-root": {
            
        // },
        marginBottom: "20px",
        paddingLeft: "10px",
        paddingRight: "10px",
        paddingTop: "10px"
    },
    text: {
        color: "inherit",
        fontSize: "14px",
    },
    textMobile: {
        color: "inherit",
        fontSize: "13px",
        a: {
            color: "inherit"
        }
    }
}

export default function Footer() {
    const { isMobile } = useIsMobile();
    const linkedinUrl = "https://www.linkedin.com/company/reinova-tech"

    return isMobile ? 
    <Stack spacing={1} sx={FooterStyle.footerMobile}>
        <Stack direction={"row"} justifyContent={"space-between"} width={"100%"}>
            <Box sx={{img: {height: "40px", width: "auto"}, marginTop: "10px"}}>
                <img src={logoImg} alt={"reinova-logo"} />
            </Box>
            <IconButton href={linkedinUrl} target="_blank">
                <img src={linkedinImg}/>
            </IconButton>
        </Stack>
        
        {/* <Stack direction={"row"} justifyContent={"space-between"} width={"100%"}>
            <Box> */}
                <Stack alignItems={"flex-start"}>
                <Typography sx={FooterStyle.textMobile}>
                    © Reinova S.p.a. – Via Albinoni 10 – 41019 Soliera (MO)
                </Typography>
                <Typography sx={FooterStyle.textMobile}>
                    Reg. Imprese/C. Fiscale/P.IVA 02769390358
                </Typography>
                </Stack>
            {/* </Box>
            <Box> */}
                <Typography sx={FooterStyle.textMobile}>
                    <a href={"/privacy"}>Privacy Policy</a>
                </Typography>
            {/* </Box>
        </Stack> */}
    </Stack>
    :
    <Stack spacing={2} direction={"row"} sx={FooterStyle.footer}>
        <Box sx={{img: {height: "40px", width: "auto"}, marginTop: "10px"}}>
            <img src={logoImg} />
        </Box>
        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"} width={"100%"}>
            <Box>
                <Stack alignItems={"flex-start"}>
                <Typography sx={FooterStyle.text}>© Reinova S.p.a. – Via Albinoni 10 – 41019 Soliera (MO)</Typography>
                <Typography sx={FooterStyle.text}>Reg. Imprese/C. Fiscale/P.IVA 02769390358</Typography>
                </Stack>
            </Box>
            <Typography sx={FooterStyle.text}>
                <Link href={"/privacy"} color={"inherit"} underline="none">Privacy Policy</Link>
                </Typography>
        </Stack>
        <IconButton href={linkedinUrl} target="_blank">
            <img src={linkedinImg}/>
        </IconButton>
    </Stack>
}